import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PrimeTemplate } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { TOAST_SEVERITY, TOAST_SEVERITY_META, ToastSeverity } from '../../models/toast.model';

const DEFAULT_SEVERITY: ToastSeverity = TOAST_SEVERITY.INFO;

@Component({
  selector: 'k-toast',
  templateUrl: 'k-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Toast, PrimeTemplate, MatIconModule],
})
export class KToastComponent {
  //* Variables
  private readonly _tones: Record<ToastSeverity, string> = {
    success: 'bg-success-soft text-success-soft-foreground border-success/30',
    error: 'bg-destructive-soft text-destructive-soft-foreground border-destructive/30',
    warn: 'bg-warning-soft text-warning-soft-foreground border-warning/35',
    info: 'bg-info-soft text-info-soft-foreground border-info/30',
  };

  //* Public Methods
  public toneClass(severity: string | undefined): string {
    return this._tones[this._resolveSeverity(severity)];
  }

  public iconFor(severity: string | undefined): string {
    return TOAST_SEVERITY_META[this._resolveSeverity(severity)].icon;
  }

  //* Private Methods
  private _resolveSeverity(severity: string | undefined): ToastSeverity {
    return (Object.values(TOAST_SEVERITY) as string[]).includes(severity ?? '')
      ? (severity as ToastSeverity)
      : DEFAULT_SEVERITY;
  }
}
